<template>
  <div>Loading...</div>
</template>

<script>
export default {
  name: 'Home',
  created () {
    window.location.href = 'https://lp.keepyou.fit/lp/app/kyf/pl_dcb_cli.html'
  },
  mounted () {
    window.location.href = 'https://lp.keepyou.fit/lp/app/kyf/pl_dcb_cli.html'
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangKyf/PL/LP.vue